module.exports = __webpack_public_path__ + "static/media/ravenous.781c3f16.jpeg";